import { Language } from "../../../../types/enum/Language"

export const LanguageNames: { [key in Language]: string } = {
  [Language.en]: "English",
  [Language.fr]: "Français",
  [Language.pt]: "Português",
  [Language.de]: "Deutsch",
  [Language.es]: "Español",
  [Language.it]: "Italiano",
  [Language.ja]: "日本語",
  [Language.nl]: "Nederlands",
  [Language.bg]: "Български"
}
